<template>
  <g>
    <path d="m20 35a12 12 0 1 0 12-12 12.013 12.013 0 0 0 -12 12zm15-9v6h6a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-6v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1-1v-6h-6a1 1 0 0 1 -1-1v-4a1 1 0 0 1 1-1h6v-6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1z"/>
    <path d="m54 4h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z"/>
    <path d="m53 15.849v-7.849h-6.015v4.412z"/>
    <path d="m24 34v2h6a1 1 0 0 1 1 1v6h2v-6a1 1 0 0 1 1-1h6v-2h-6a1 1 0 0 1 -1-1v-6h-2v6a1 1 0 0 1 -1 1z"/>
    <path d="m31.5 6.436-25.361 14.494a1 1 0 0 0 -.4 1.315l.208.417a.994.994 0 0 0 .6.51.979.979 0 0 0 .786-.089l23.179-13.241a3.009 3.009 0 0 1 2.977 0l23.172 13.241a.983.983 0 0 0 .786.089.994.994 0 0 0 .6-.51l.208-.417a1 1 0 0 0 -.4-1.315l-25.355-14.494a1 1 0 0 0 -1 0z"/>
    <path d="m5 60h54a1 1 0 0 0 0-2h-54a1 1 0 0 0 0 2z"/>
    <path d="m17 35a15 15 0 1 0 15-15 15.017 15.017 0 0 0 -15 15zm29 0a14 14 0 1 1 -14-14 14.015 14.015 0 0 1 14 14z"/>
    <path d="m31.5 11.578-20.5 11.722v32.7h42v-32.706l-20.5-11.716a1 1 0 0 0 -1 0zm-14.5 42.422h-4v-2h4zm4 0h-2v-2h2zm24 0h-2v-2h2zm6 0h-4v-2h4zm-2-19a17 17 0 1 1 -17-17 17.019 17.019 0 0 1 17 17z"/>
  </g>
</template>

<script>
export default {
  data() {
    return {
      viewBox: '0 0 64 64',
    };
  },
};
</script>
